<template>
    <div class="custom-date-range-picker">
        <el-date-picker ref="startDatePickerRef" v-model="startDateTime" :type="config.type === 'datetime' ? 'datetime' : 'date'" :placement="pickerPlacement" :clearable="false"
            :disabled-date="config.disabledDate ? config.disabledDate : startDateDisabledDate"
            :value-format="config.formatType ? config.formatType : 'YYYY-MM-DD'"
            :placeholder="config.placeholder ? $t(`${config.placeholder}`) : $t('开始时间')" :popper-options="{
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: [fallbackPlacement],
                            allowedAutoPlacements: [fallbackPlacement]
                        }
                    }
                ]
            }" @change="handleStartDateTimeChange" @blur="handleStartDateTimeBlur">
        </el-date-picker>
        <span class="mg-r--10" style="padding-bottom: 2px;">-</span>
        <el-date-picker class="end-data-picker" ref="endDatePickerRef" v-model="endDateTime" :type="config.type === 'datetime' ? 'datetime' : 'date'" :placement="pickerPlacement" :clearable="false"
            :disabled-date="config.disabledDate ? config.disabledDate : endDateDisabledDate"
            :value-format="config.formatType ? config.formatType : 'YYYY-MM-DD'"
            :placeholder="config.placeholder ? $t(`${config.placeholder}`) : $t('结束时间')" :popper-options="{
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: [fallbackPlacement],
                            allowedAutoPlacements: [fallbackPlacement]
                        }
                    }
                ]
            }" @change="handleEndDateTimeChange" @blur="handleEndDateTimeBlur">
        </el-date-picker>
        <i v-if="startDateTime && endDateTime" @click="onClearBtnClick" style="color: #909399;"
            class="clear-btn pointer el-icon el-input__icon clear-icon"><svg viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor"
                    d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248L466.752 512z">
                </path>
                <path fill="currentColor"
                    d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768zm0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896z">
                </path>
            </svg>
        </i>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Array],
        default: ''
    },
    config: {
        type: Object,
        default: {}
    }
});

const pickerPlacement = computed(() => props.config.placement || 'bottom-start');
const fallbackPlacement = computed(() => pickerPlacement.value.startsWith('top') ? 'top' : 'bottom');

const startDatePickerRef = ref();
const endDatePickerRef = ref();

const startDateTime = ref('');
const endDateTime = ref('');

const startDateDisabledDate = (time) => {
    return time.getTime() >= new Date(endDateTime.value).getTime();
};

const endDateDisabledDate = (time) => {
    return time.getTime() <= new Date(startDateTime.value).getTime() - 1 * 8.64e7;
};

const emit = defineEmits(['update:modelValue', 'change']);

const handleStartDateTimeChange = (value) => {
    if (value && !endDateTime.value) {
        endDatePickerRef.value && endDatePickerRef.value.focus();
    }
};

const handleEndDateTimeChange = (value) => {
    if (!value) {
        startDateTime.value = '';
        endDateTime.value = '';
        emit('change', [startDateTime.value, endDateTime.value]);
        emit('update:modelValue', [startDateTime.value, endDateTime.value]);
    } else {
        if (!startDateTime.value) {
            startDatePickerRef.value && startDatePickerRef.value.focus();
        }
    }
};

const handleStartDateTimeBlur = () => {
    if (!startDateTime.value) {
        startDateTime.value = '';
        endDateTime.value = '';
        emit('update:modelValue', '');
    }
};

const handleEndDateTimeBlur = () => {
    if (!endDateTime.value) {
        startDateTime.value = '';
        endDateTime.value = '';
        emit('update:modelValue', '');
    }
};

const onClearBtnClick = () => {
    startDateTime.value = '';
    endDateTime.value = '';
    emit('update:modelValue', '');
    emit('change');
};

watch(() => props.modelValue, (val) => {
    if (Array.isArray(val)) {
        startDateTime.value = val[0] ? val[0] : '';
        endDateTime.value = val[1] ? val[1] : '';
    } else {
        startDateTime.value = '';
        endDateTime.value = '';
    }
}, { immediate: true });

watch(() => [startDateTime.value, endDateTime.value], (val) => {
    if (val[0] && val[1]) {
        emit('update:modelValue', [startDateTime.value, endDateTime.value]);
        emit('change');
    } else {
        emit('update:modelValue', '');
    }
});

</script>

<style lang="less" scoped>
.custom-date-range-picker {
    display: flex;
    // justify-content: center;
    align-items: center;

    &:hover {
        .clear-btn {
            visibility: visible;
        }
    }

    :deep(.end-data-picker) {
        .el-input__wrapper {
            .el-input__prefix {
                display: none !important;
            }
        }
    }

    :deep(.el-input__inner) {
        line-height: normal !important;
    }

    .clear-btn {
        visibility: hidden;
        position: absolute;
        right: 10px;
    }
}
</style>
